
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 22 22"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M11 6c-3.44 0-6.558 1.882-8.86 4.938a.713.713 0 000 .85c2.302 3.06 5.42 4.942 8.86 4.942 3.44 0 6.558-1.882 8.86-4.938a.713.713 0 000-.85C17.557 7.881 14.44 6 11 6zm.247 9.143a3.788 3.788 0 01-4.025-4.025 3.794 3.794 0 013.531-3.531 3.788 3.788 0 014.025 4.025 3.806 3.806 0 01-3.531 3.53zm-.114-1.746a2.035 2.035 0 01-2.166-2.165 2.047 2.047 0 011.904-1.903 2.035 2.035 0 012.165 2.165 2.047 2.047 0 01-1.903 1.903z"}})])
          )
        }
      }
    